export const isOpenedInNewTab = (searchParams: URLSearchParams): boolean =>
  searchParams.get('newTab') === 'true' ||
  searchParams.get('newWindow') === 'true';

export const getNewTabSearch = (searchParams: URLSearchParams): string =>
  isOpenedInNewTab(searchParams) ? '?newTab=true' : '';

const addNewTabParamForInternalUrl = (path: string): string => {
  try {
    const url = new URL(path, window.location.origin);

    // Add app-specific new-tab marker only for same-origin URLs.
    if (url.origin !== window.location.origin) {
      return path;
    }

    url.searchParams.set('newTab', 'true');

    // Preserve relative shape for app routes.
    if (!/^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(path)) {
      return `${url.pathname}${url.search}${url.hash}`;
    }

    return url.toString();
  } catch {
    return path;
  }
};

export const openNewWindow = async (
  path: string,
  title = '',
  _width?: number,
  _height?: number,
) => {
  const pathWithParam = addNewTabParamForInternalUrl(path);
  const target = title || '_blank';
  const newTab = window.open(pathWithParam, target);

  if (newTab) {
    try {
      newTab.opener = null;
    } catch {
      // Cross-origin tabs may not allow setting opener.
    }
    newTab.focus();
  }
};
